<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    :title="$t('components.memberimportsalaries.update_earnings')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="attach_money"
  >
    <v-card-text>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        @itemsChanged="setData($event)"
        identifier="membersImportSalaries"
        @error="error = $event"
        @items-change-warning="itemsChangeWarning($event)"
        :itemsChangeWarning="true"
        :showSelect="false"
        v-if="provider !== null && provider !== undefined"
      >
        <template
          v-for="(header, index) in provider.headers.filter(
            (h) =>
              h.type.key === 'CurrentEmploymentInformation/Earnings' ||
              h.type.key === 'CurrentEmploymentInformation/EffectiveDate' ||
              h.type.key ===
                'CurrentEmploymentInformation/EmploymentType/Translations[]/DisplayValue' ||
              h.type.key ===
                'CurrentEmploymentInformation/EmploymentFrequency/Translations[]/DisplayValue' ||
              h.type.key === 'CurrentEmploymentInformation/WeeklyHours' ||
              h.type.key ===
                'CurrentEmploymentInformation/SecondIncomeEarnings' ||
              h.type.key ===
                'CurrentEmploymentInformation/SecondIncomeType/Translations[]/DisplayValue' ||
              h.type.key ===
                'CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Translations[]/DisplayValue'
          )"
          v-slot:[itemSlotFunc(header)]="{ header, item }"
        >
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'CurrentEmploymentInformation/Earnings'"
          >
            <template v-slot:activator="{ on, attrs }">
              <currency-textfield
                style="min-width: 200px"
                v-bind="attrs"
                v-on="on"
                :value="item.CurrentEmploymentInformation.Earnings"
                @change="updateEarnings($event, item)"
                :rules="
                  editableHeaders['CurrentEmploymentInformation/Earnings']
                    .isOptional === false
                    ? [$rules.requiredNum]
                    : []
                "
                :class="
                  editableHeaders['CurrentEmploymentInformation/Earnings']
                    .isOptional === false
                    ? 'required'
                    : ''
                "
              />
              <!-- <no-autocomplete-textfield
                style="min-width: 200px"
                v-bind="attrs"
                v-on="on"
                @blur="earningsBlur(item)"
                :value="item.CurrentEmploymentInformation.Earnings"
                @change="updateEarnings($event, item)"
                prefix="$"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp"
                :rules="
                  columnRules(
                    editableHeaders['CurrentEmploymentInformation/Earnings']
                  )
                "
                :class="
                  editableHeaders['CurrentEmploymentInformation/Earnings']
                    .isOptional === false
                    ? 'required'
                    : []
                "
              ></no-autocomplete-textfield> -->
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalEarnings(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key ===
                'CurrentEmploymentInformation/SecondIncomeEarnings'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <currency-textfield
                style="min-width: 200px"
                v-bind="attrs"
                v-on="on"
                :value="item.CurrentEmploymentInformation.SecondIncomeEarnings"
                @change="updateSecondIncomeEarnings($event, item)"
                :rules="
                  editableHeaders[
                    'CurrentEmploymentInformation/SecondIncomeEarnings'
                  ].isOptional === false
                    ? [$rules.requiredNum]
                    : []
                "
                :class="
                  editableHeaders[
                    'CurrentEmploymentInformation/SecondIncomeEarnings'
                  ].isOptional === false
                    ? 'required'
                    : ''
                "
              />
              <!-- <no-autocomplete-textfield
                style="min-width: 200px"
                v-bind="attrs"
                v-on="on"
                @blur="secondIncomeEarningsBlur(item)"
                :value="item.CurrentEmploymentInformation.SecondIncomeEarnings"
                @change="updateSecondIncomeEarnings($event, item)"
                prefix="$"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp"
                :rules="
                  columnRules(
                    editableHeaders[
                      'CurrentEmploymentInformation/SecondIncomeEarnings'
                    ]
                  )
                "
                :class="
                  editableHeaders[
                    'CurrentEmploymentInformation/SecondIncomeEarnings'
                  ].isOptional === false
                    ? 'required'
                    : []
                "
              ></no-autocomplete-textfield> -->
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalSecondIncomeEarnings(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key === 'CurrentEmploymentInformation/WeeklyHours'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <no-autocomplete-textfield
                v-bind="attrs"
                v-on="on"
                :value="item.CurrentEmploymentInformation.WeeklyHours"
                @change="updateWeeklyHours($event, item)"
                :rules="
                  columnRules(
                    editableHeaders['CurrentEmploymentInformation/WeeklyHours']
                  )
                "
                :class="
                  editableHeaders['CurrentEmploymentInformation/WeeklyHours']
                    .isOptional === false
                    ? 'required'
                    : ''
                "
              ></no-autocomplete-textfield>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalWeeklyHours(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'CurrentEmploymentInformation/EffectiveDate'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <pbas-date-picker
                  style="margin:0 auto 15px"
                  :value="item.CurrentEmploymentInformation.EffectiveDate"
                  @update-date="updateEffectiveDate($event, item)"
                  :rules="[
                    $rules.required,
                    (val) => rules.coverageEffectiveDate(val, item),
                  ]"
                  class="required"
                  :allowedDates="(val) => coverageAllowedDates(val, item)"
                />
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalEffectiveDate(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key ===
                'CurrentEmploymentInformation/EmploymentType/Translations[]/DisplayValue'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select
                  style="margin:0 auto"
                  :value="item.CurrentEmploymentInformation.EmploymentType"
                  :items="columnsDropDownOptions.Models.EmploymentType"
                  item-value="Id"
                  @change="updateEmploymentType($event, item)"
                  :slots="true"
                  return-object
                  :filter="filterFunc"
                  :rules="
                    columnRules(
                      editableHeaders[
                        'CurrentEmploymentInformation/EmploymentType'
                      ]
                    )
                  "
                  :class="
                    editableHeaders[
                      'CurrentEmploymentInformation/EmploymentType'
                    ].isOptional === false
                      ? 'required'
                      : ''
                  "
                  :clearable="
                    editableHeaders[
                      'CurrentEmploymentInformation/EmploymentType'
                    ].isOptional !== false
                  "
                >
                  <template v-slot:selection="data">
                    {{ translate(data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="translate(data.item)"
                    ></v-list-item-content>
                  </template>
                </v-select>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalEmploymentType(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key ===
                'CurrentEmploymentInformation/EmploymentFrequency/Translations[]/DisplayValue'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select
                  v-bind="attrs"
                  v-on="on"
                  style="margin:0 auto"
                  :value="item.CurrentEmploymentInformation.EmploymentFrequency"
                  :items="columnsDropDownOptions.Models.EmploymentFrequency"
                  item-value="Id"
                  @change="updateEarningsFrequency($event, item)"
                  :slots="true"
                  return-object
                  :filter="filterFunc"
                  :rules="
                    columnRules(
                      editableHeaders[
                        'CurrentEmploymentInformation/EmploymentFrequency'
                      ]
                    )
                  "
                  :class="
                    editableHeaders[
                      'CurrentEmploymentInformation/EmploymentFrequency'
                    ].isOptional === false
                      ? 'required'
                      : ''
                  "
                  :clearable="
                    editableHeaders[
                      'CurrentEmploymentInformation/EmploymentFrequency'
                    ].isOptional !== false
                  "
                >
                  <template v-slot:selection="data">
                    {{ translate(data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="translate(data.item)"
                    ></v-list-item-content>
                  </template>
                </v-select>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalEmploymentFrequency(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key ===
                'CurrentEmploymentInformation/SecondIncomeType/Translations[]/DisplayValue'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select
                  v-bind="attrs"
                  v-on="on"
                  style="margin:0 auto"
                  :value="item.CurrentEmploymentInformation.SecondIncomeType"
                  :items="columnsDropDownOptions.Models.IncomeType"
                  item-value="Id"
                  @change="updateSecondIncomeType($event, item)"
                  :slots="true"
                  return-object
                  :filter="filterFunc"
                  :rules="
                    columnRules(
                      editableHeaders[
                        'CurrentEmploymentInformation/SecondIncomeType'
                      ]
                    )
                  "
                  :class="
                    editableHeaders[
                      'CurrentEmploymentInformation/SecondIncomeType'
                    ].isOptional === false
                      ? 'required'
                      : ''
                  "
                  :clearable="
                    editableHeaders[
                      'CurrentEmploymentInformation/SecondIncomeType'
                    ].isOptional !== false
                  "
                >
                  <template v-slot:selection="data">
                    {{ translate(data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="translate(data.item)"
                    ></v-list-item-content>
                  </template>
                </v-select>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalSecondIncomeType(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="
              header.type.key ===
                'CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Translations[]/DisplayValue'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select
                  v-bind="attrs"
                  v-on="on"
                  style="margin:0 auto"
                  :value="
                    item.CurrentEmploymentInformation
                      .SecondIncomeEarningsFrequency
                  "
                  :items="columnsDropDownOptions.Models.EmploymentFrequency"
                  item-value="Id"
                  @change="updateSecondIncomeEarningsFrequency($event, item)"
                  :slots="true"
                  return-object
                  :filter="filterFunc"
                  :rules="
                    columnRules(
                      editableHeaders[
                        'CurrentEmploymentInformation/SecondIncomeEarningsFrequency'
                      ]
                    )
                  "
                  :class="
                    editableHeaders[
                      'CurrentEmploymentInformation/SecondIncomeEarningsFrequency'
                    ].isOptional === false
                      ? 'required'
                      : ''
                  "
                  :clearable="
                    editableHeaders[
                      'CurrentEmploymentInformation/SecondIncomeEarningsFrequency'
                    ].isOptional !== false
                  "
                >
                  <template v-slot:selection="data">
                    {{ translate(data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="translate(data.item)"
                    ></v-list-item-content>
                  </template>
                </v-select>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalSecondIncomeEarningsFrequency(item) }}</b>
            </span>
          </v-tooltip>
        </template>
      </pbas-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        @click="discardDialog=true"
        :disabled="discardDisabled"
      >
        {{ $t("components.memberimportsalaries.discard_changes") }}
      </v-btn>
      <v-btn color="primary" @click="save" :disabled="saveDisabled">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="warningDialog" persistent max-width="800">
      <material-card
        :title="$t('components.memberimportsalaries.warning_title')"
        icon="warning"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberimportsalaries.warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="itemsChangeWarningNo">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesDiscard">
            {{ $t("components.memberimportsalaries.discard_changes") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesSave">
            {{ $t("components.memberimportsalaries.save_changes") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="locking" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="discardDialog" persistent max-width="800">
      <material-card
        :title="$t('components.memberimportsalaries.warning_title')"
        icon="warning"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberimportsalaries.dicard_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="discardDialog=false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="discard">
            {{ $t("components.memberimportsalaries.discard_changes") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import { ODataHeader, HeaderAlignment, ODataDate } from "pbas-vue-components";
import { translate2 } from "../trans2";
import { translate } from "../trans";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { locker } from "../mixins/locker";
import { planSetter } from "../mixins/planSetter";
import CurrencyTextfield from '../components/CurrencyTextfield.vue';
export default {
  name: "members-import-salaries",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    CurrencyTextfield
  },
  mixins: [locker, planSetter],
  data() {
    return {
      rules: {
        coverageEffectiveDate: (v, item) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            item === null ||
            item === undefined ||
            item.CoverageEffectiveDate === null ||
            item.CoverageEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(item.CoverageEffectiveDate);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatValidationDate(d),
            ]);
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [this.formatValidationDate(d)])
          );
        },
      },
      show: true,
      locking: true,
      editableHeaders: {},
      discardDisabled: true,
      warningOptions: {},
      warningDialog: false,
      discardDialog: false,
      saveDisabled: true,
      originalData: [],
      error: null,
      provider: undefined,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
    }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "bulkUpdateEmploymentInfo",
      "lockMassive",
    ]),
    ...mapActions("common", ["createOdataType"]),
    async loadPlanData() {
      try {
        let headers;
        headers = (await this.getMembersManagementColumns(
          this.selectedPlan.Id
        )).data
          .filter((h) => h.showOnExpandOnly !== true)
          .sort((a, b) => {
            return a.order - b.order;
          });
        const readonlyHeaders = headers.filter(
          (o) =>
            o.value === "Id" ||
            o.value === "MemberIdentification/Certificate" ||
            o.value === "CurrentMember/FirstName" ||
            o.value === "CurrentMember/LastName" ||
            o.value === "CurrentEmploymentInformation/Employer/Id" ||
            o.value ===
              "CurrentEmploymentInformation/Employer/Current/Translations[]/Name" ||
            o.value ===
              "CurrentEmploymentInformation/Employer/Current/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/Store/Id" ||
            o.value ===
              "CurrentEmploymentInformation/Store/Current/Translations[]/Name" ||
            o.value ===
              "CurrentEmploymentInformation/Store/Current/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/Occupation" ||
            o.value === "CurrentEmploymentInformation/SalaryEvidenceProvided" ||
            o.value === "CurrentEmploymentInformation/EmployeeNumber" ||
            o.value === "CurrentEmploymentInformation/EmployerContribution" ||
            o.value === "CurrentEmploymentInformation/HireDate"
        );
        const editableHeaders = headers.filter(
          (o) =>
            o.value === "CurrentEmploymentInformation/EmploymentFrequency" ||
            o.value === "CurrentEmploymentInformation/EmploymentFrequency/Id" ||
            o.value ===
              "CurrentEmploymentInformation/EmploymentFrequency/Translations[]/DisplayValue" ||
            o.value ===
              "CurrentEmploymentInformation/EmploymentFrequency/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/EmploymentType" ||
            o.value === "CurrentEmploymentInformation/EmploymentType/Id" ||
            o.value ===
              "CurrentEmploymentInformation/EmploymentType/Translations[]/DisplayValue" ||
            o.value ===
              "CurrentEmploymentInformation/EmploymentType/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/Earnings" ||
            o.value === "CurrentEmploymentInformation/WeeklyHours" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeEarningsFrequency" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Id" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Translations[]/DisplayValue" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/SecondIncomeType" ||
            o.value === "CurrentEmploymentInformation/SecondIncomeType/Id" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeType/Translations[]/DisplayValue" ||
            o.value ===
              "CurrentEmploymentInformation/SecondIncomeType/Translations[]/LanguageCode" ||
            o.value === "CurrentEmploymentInformation/SecondIncomeEarnings"
        );

        if (headers.length === 0) {
          this.error = {
            customMessage: this.$t("errors.no_headers"),
          };
          return;
        }

        editableHeaders.push(
          headers.filter((o) => o.value === "CurrentMember/EffectiveDate").map(o=>{
            o.value = "CurrentEmploymentInformation/EffectiveDate";
            return o;
          })[0]
        );
        for (const header of editableHeaders) {
          this.editableHeaders[header.value] = header;
        }
        const h2 = this.$helpers.createOdataHeaders(
          readonlyHeaders.concat(editableHeaders),
          "headers.members_management."
        );
        for (let header of h2) {
          if (header.type.key === "CurrentEmploymentInformation/Occupation") {
            header.type.getHtml = (item, type) => {
              return (
                "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
                type.getString(item, type) +
                "</div>"
              );
            };
            break;
          }
        }

        const url = "plans/" + this.selectedPlan.Id + "/find-members";
        console.log(h2);
        this.provider = new PbasOData(
          this.$axiosHttp,
          url,
          h2.concat(
            new ODataHeader({
              title: "headers.members_management.coverage_effective_date",
              type: new ODataDate("CoverageEffectiveDate", {}),
              sortable: false,
              visible: false,
              searchable: false,
              isIdentifier: false,
              allowVisibilityChange: false,
              alwaysInclude: true,
              version: 22,
            })
          )
        );
      } catch (error) {
        this.error = error;
      }
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    coverageAllowedDates(val, item) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(item.CoverageEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    displayOriginalEffectiveDate(item) {
      return this.formatDate(
        this.originalData.filter((o) => o.Id === item.Id)[0].CurrentMember
          .EffectiveDate
      );
    },
    displayOriginalEarnings(item) {
      return this.formatCurrency(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.Earnings
      );
    },
    displayOriginalSecondIncomeEarnings(item) {
      return this.formatCurrency(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.SecondIncomeEarnings
      );
    },
    displayOriginalWeeklyHours(item) {
      return this.originalData.filter((o) => o.Id === item.Id)[0]
        .CurrentEmploymentInformation.WeeklyHours;
    },
    displayOriginalEmploymentType(item) {
      return this.translate(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.EmploymentType
      );
    },
    displayOriginalEmploymentFrequency(item) {
      return this.translate(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.EmploymentFrequency
      );
    },
    displayOriginalSecondIncomeType(item) {
      return this.translate(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.SecondIncomeType
      );
    },
    displayOriginalSecondIncomeEarningsFrequency(item) {
      return this.translate(
        this.originalData.filter((o) => o.Id === item.Id)[0]
          .CurrentEmploymentInformation.SecondIncomeEarningsFrequency
      );
    },
    async itemsChangeWarningNo() {
      this.$refs.table.itemsChangeWarningNo(this.warningOptions);
      this.warningDialog = false;
    },
    async itemsChangeWarningYesDiscard() {
      await this.unlock();
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.warningDialog = false;
    },
    async itemsChangeWarningYesSave() {
      await this.save();
      await this.unlock();
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.warningDialog = false;
    },
    columnRules(column) {
      // console.log(column);
      let rules = [];
      if (column.isOptional === false) {
        if (column.type === "double" || column.type === "int" || column.type === "currency") {
          rules.push(this.$rules.requiredNum);
        } else {
          rules.push(this.$rules.required);
        }
      }
      if (column.validationPattern)
        rules.push((v) => {
          return (
            !v ||
            new RegExp(column.validationPattern).test(String(v)) ||
            this.$t(
              "components.memberimportsalaries." + column.validationMessage
            )
          );
        });
      return rules;
    },
    async itemsChangeWarning(options) {
      const changesExist =
        this.$refs.table.fetchResult.items.filter((o) => o.modified).length > 0;
      console.log(changesExist);
      if (changesExist) {
        this.warningOptions = options;
        this.warningDialog = true;
      } else {
        await this.unlock();
        this.$refs.table.itemsChangeWarningYes(options);
      }
    },
    filterFunc(item, search) {
      return (
        item.FirstName.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        item.LastName.toLowerCase().indexOf(search.toLowerCase()) > -1
      );
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    translate(item) {
      return translate(item, this.language.language);
    },
    async setData(items) {
      console.log("set data");
      this.locking = true;
      this.originalData = JSON.parse(JSON.stringify(items));
      this.setSaveDisabled();
      try {
        await this.lock(
          this.lockMassive,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityIds: items.map((o) => o.Id),
          },
          () => {
            this.$router.push({ name: "members", params: { planId: this.selectedPlan.Id } });
          }
        );
      } catch (error) {
        this.error = error;
        setTimeout(() => {
          this.$router.push({ name: "members", params: { planId: this.selectedPlan.Id } });
        }, 1000);
      }

      this.locking = false;
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    isRowModified(row, original) {
      let modified = false;
      let editableHeaders = Object.keys(this.editableHeaders);
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/EmploymentFrequency/Id"
        ) > -1
      ) {
        if (
          row.CurrentEmploymentInformation.EmploymentFrequency &&
          original.CurrentEmploymentInformation.EmploymentFrequency
        ) {
          modified =
            row.CurrentEmploymentInformation.EmploymentFrequency.Id !==
            original.CurrentEmploymentInformation.EmploymentFrequency.Id;
        } else {
          modified =
            row.CurrentEmploymentInformation.EmploymentFrequency !==
            original.CurrentEmploymentInformation.EmploymentFrequency;
        }
      }
      if (modified) {
        return modified;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/EmploymentType/Id"
        ) > -1
      ) {
        if (
          row.CurrentEmploymentInformation.EmploymentType &&
          original.CurrentEmploymentInformation.EmploymentType
        ) {
          modified =
            row.CurrentEmploymentInformation.EmploymentType.Id !==
            original.CurrentEmploymentInformation.EmploymentType.Id;
        } else {
          modified =
            row.CurrentEmploymentInformation.EmploymentType !==
            original.CurrentEmploymentInformation.EmploymentType;
        }
      }
      if (modified) {
        return modified;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeEarningsFrequency/Id"
        ) > -1
      ) {
        if (
          row.CurrentEmploymentInformation.SecondIncomeEarningsFrequency &&
          original.CurrentEmploymentInformation.SecondIncomeEarningsFrequency
        ) {
          modified =
            row.CurrentEmploymentInformation.SecondIncomeEarningsFrequency
              .Id !==
            original.CurrentEmploymentInformation.SecondIncomeEarningsFrequency
              .Id;
        } else {
          modified =
            row.CurrentEmploymentInformation.SecondIncomeEarningsFrequency !==
            original.CurrentEmploymentInformation.SecondIncomeEarningsFrequency;
        }
      }
      if (modified) {
        console.log("asdasd");
        return modified;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeType/Id"
        ) > -1
      ) {
        if (
          row.CurrentEmploymentInformation.SecondIncomeType &&
          original.CurrentEmploymentInformation.SecondIncomeType
        ) {
          modified =
            row.CurrentEmploymentInformation.SecondIncomeType.Id !==
            original.CurrentEmploymentInformation.SecondIncomeType.Id;
        } else {
          modified =
            row.CurrentEmploymentInformation.SecondIncomeType !==
            original.CurrentEmploymentInformation.SecondIncomeType;
        }
      }
      if (modified) {
        return modified;
      }
      if (
        editableHeaders.indexOf("CurrentEmploymentInformation/Earnings") > -1
      ) {
        modified =
          row.CurrentEmploymentInformation.Earnings !==
          original.CurrentEmploymentInformation.Earnings;
      }
      if (modified) {
        return modified;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeEarnings"
        ) > -1
      ) {
        modified =
          row.CurrentEmploymentInformation.SecondIncomeEarnings !==
          original.CurrentEmploymentInformation.SecondIncomeEarnings;
      }
      if (modified) {
        return modified;
      }
      if (
        editableHeaders.indexOf("CurrentEmploymentInformation/WeeklyHours") > -1
      ) {
        modified =
          row.CurrentEmploymentInformation.WeeklyHours !==
          original.CurrentEmploymentInformation.WeeklyHours;
      }
      return modified;
    },
    isColumnValid(column, value) {
      // console.log(column.value, column.isOptional, value);
      let valid = true;
      if (column.isOptional === false) {
        valid = value !== null && value !== undefined;
      }
      // console.log(valid);
      if (!valid) {
        return valid;
      }
      if (column.validationPattern) {
        valid =
          value === null ||
          value === undefined ||
          new RegExp(column.validationPattern).test(String(value));
      }
      // console.log(valid);
      return valid;
    },
    isRowValid(row) {
      let valid = true;
      let editableHeaders = Object.keys(this.editableHeaders);
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/EmploymentFrequency"
        ) > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders[
            "CurrentEmploymentInformation/EmploymentFrequency"
          ],
          row.CurrentEmploymentInformation.EmploymentFrequency
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf("CurrentEmploymentInformation/EmploymentType") >
        -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders["CurrentEmploymentInformation/EmploymentType"],
          row.CurrentEmploymentInformation.EmploymentType
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeEarningsFrequency"
        ) > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders[
            "CurrentEmploymentInformation/SecondIncomeEarningsFrequency"
          ],
          row.CurrentEmploymentInformation.SecondIncomeEarningsFrequency
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeType"
        ) > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders["CurrentEmploymentInformation/SecondIncomeType"],
          row.CurrentEmploymentInformation.SecondIncomeType
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf("CurrentEmploymentInformation/Earnings") > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders["CurrentEmploymentInformation/Earnings"],
          row.CurrentEmploymentInformation.Earnings
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf(
          "CurrentEmploymentInformation/SecondIncomeEarnings"
        ) > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders[
            "CurrentEmploymentInformation/SecondIncomeEarnings"
          ],
          row.CurrentEmploymentInformation.SecondIncomeEarnings
        );
      }
      if (!valid) {
        return valid;
      }
      if (
        editableHeaders.indexOf("CurrentEmploymentInformation/WeeklyHours") > -1
      ) {
        valid = this.isColumnValid(
          this.editableHeaders["CurrentEmploymentInformation/WeeklyHours"],
          row.CurrentEmploymentInformation.WeeklyHours
        );
      }
      // console.log(row);
      return (
        valid &&
        row.CurrentEmploymentInformation.EffectiveDate !== null &&
        row.CurrentEmploymentInformation.EffectiveDate !== undefined
      );
    },
    updateEarnings(value, row) {
      console.log(value, row);
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.Earnings = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateSecondIncomeEarnings(value, row) {
      console.log(value, row);
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.SecondIncomeEarnings = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateWeeklyHours(value, row) {
      console.log(value, row);
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.WeeklyHours = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateEmploymentType(value, row) {
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.EmploymentType = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateEarningsFrequency(value, row) {
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.EmploymentFrequency = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateSecondIncomeType(value, row) {
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.SecondIncomeType = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateSecondIncomeEarningsFrequency(value, row) {
      if (value === null || value === undefined) {
        return;
      }
      row.CurrentEmploymentInformation.SecondIncomeEarningsFrequency = value;
      const original = this.originalData.filter((o) => o.Id === row.Id)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    updateEffectiveDate(value, row) {
      row.CurrentEmploymentInformation.EffectiveDate = value;
      row.valid = this.isRowValid(row);
      this.setSaveDisabled();
    },
    setSaveDisabled() {
      if (
        this.$refs.table === null ||
        this.$refs.table === undefined ||
        this.$refs.table.fetchResult === null ||
        this.$refs.table.fetchResult === undefined
      ) {
        this.saveDisabled = true;
        this.discardDisabled = true;
        return;
      }
      this.saveDisabled =
        this.$refs.table.fetchResult.items.filter((o) => o.modified && o.valid)
          .length === 0;
      this.discardDisabled =
        this.$refs.table.fetchResult.items.filter((o) => o.modified).length ===
        0;
    },
    async save() {
      try {
        let items = JSON.parse(
          JSON.stringify(
            this.$refs.table.fetchResult.items.filter(
              (o) => o.modified && o.valid
            )
          )
        );
        await this.bulkUpdateEmploymentInfo({
          planIdentityId: this.selectedPlan.Id,
          payload: items.map((o) => {
            if (o.CurrentEmploymentInformation.EmploymentFrequency) {
              o.CurrentEmploymentInformation.EmploymentFrequencyId =
                o.CurrentEmploymentInformation.EmploymentFrequency.Id;
              delete o.CurrentEmploymentInformation.EmploymentFrequency;
            }
            if (o.CurrentEmploymentInformation.EmploymentType) {
              o.CurrentEmploymentInformation.EmploymentTypeId =
                o.CurrentEmploymentInformation.EmploymentType.Id;
              delete o.CurrentEmploymentInformation.EmploymentType;
            }
            if (o.CurrentEmploymentInformation.SecondIncomeEarningsFrequency) {
              o.CurrentEmploymentInformation.SecondIncomeEarningsFrequencyId =
                o.CurrentEmploymentInformation.SecondIncomeEarningsFrequency.Id;
              delete o.CurrentEmploymentInformation
                .SecondIncomeEarningsFrequency;
            }
            if (o.CurrentEmploymentInformation.SecondIncomeType) {
              o.CurrentEmploymentInformation.SecondIncomeTypeId =
                o.CurrentEmploymentInformation.SecondIncomeType.Id;
              delete o.CurrentEmploymentInformation.SecondIncomeType;
            }
            if (o.CurrentEmploymentInformation.Employer) {
              o.CurrentEmploymentInformation.EmployerId =
                o.CurrentEmploymentInformation.Employer.Id;
              delete o.CurrentEmploymentInformation.Employer;
            }
            if (o.CurrentEmploymentInformation.Store) {
              o.CurrentEmploymentInformation.StoreId =
                o.CurrentEmploymentInformation.Store.Id;
              delete o.CurrentEmploymentInformation.Store;
            }
            o.CurrentEmploymentInformation.IdentityId = o.Id;
            if (o.Earnings) {
              o.Earnings = parseFloat(o.Earnings);
            }
            if (o.WeeklyHours) {
              o.WeeklyHours = parseInt(o.WeeklyHours);
            }
            if (o.SecondIncomeEarnings) {
              o.SecondIncomeEarnings = parseFloat(o.SecondIncomeEarnings);
            }
            return o.CurrentEmploymentInformation;
          }),
        });
        await this.unlock();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    async discard() {
      // if (this.$refs)
      await this.unlock();
      this.discardDialog = false;
      await this.$refs.table.getDataAsync();
      this.setSaveDisabled();
    },
  },
};
</script>
<style scoped>
.previous-value-tooltip {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.v-tooltip__content {
  background-color: orange;
  max-width: fit-content !important;
  width: fit-content !important;
}
</style>
